import { createGlobalStyle, css } from "styled-components";
import reset from "styled-reset";
import { colors } from "./theme";
import markdownStyle from "./markdownStyle";

const GlobalStyle = createGlobalStyle`

    

  ${() => {
    return css`
      ${reset}
      ${markdownStyle}

      @font-face {
        font-family: "Pretendard";
        src: url("/fonts/PretendardVariable.woff2") format("woff2");
        font-weight: 45 920;
        font-style: normal;
        font-display: swap;
      }

      .material-symbols-outlined {
        font-family: "Material Symbols Outlined";
        font-variation-settings: "FILL" 1, "wght" 400, "GRAD" 0, "opsz" 24;
      }

      /* 폰트 로딩 확인용 */
      .font-loaded {
        font-family: "Pretendard", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
          "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
      }

      /* 폰트 적용 강화 */
      * {
        font-family: "Pretendard", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
          "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
      }

      /* Material Symbols Icons */
      .material-symbols-outlined {
        font-family: "Material Symbols Outlined" !important;
        font-weight: normal;
        font-style: normal;
        font-size: 24px;
        line-height: 1;
        letter-spacing: normal;
        text-transform: none;
        display: inline-block;
        white-space: nowrap;
        word-wrap: normal;
        direction: ltr;
        -webkit-font-feature-settings: "liga";
        -webkit-font-smoothing: antialiased;
        font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 24;
      }

      .div1 {
        color: var(--Teeshot-Neutrals-Color-Teeshot-Black, #1a1a1a);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 24px;
      }

      .div2 {
        color: var(--Teeshot-Neutrals-Color-Teeshot-Black, #1a1a1a);

        /* P14/P14M */
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 150%; /* 21px */
      }
      .hd {
        color: var(--Teeshot-Neutrals-Color-Teeshot-Black, #1a1a1a);
        text-align: center;

        /* 18_H2/18B */
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 22px; /* 122.222% */
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
        /* color: ${colors.black.default} */
        /* color: #1d1d1d */
        scrollbar-gutter: stable;
      }

      body,
      html,
      #root {
        font-family: "Pretendard", "Helvetica", "Arial", sans-serif;
        line-height: 1.5;
        max-width: 800px;
        margin: 0 auto;
        min-height: 100dvh;
      }
      #root {
        display: flex;
        flex-direction: column;
      }

      input,
      textarea {
        font-family: Arial;
        color: #333;
      }
      .header-height {
        height: 55px !important;
        min-height: 55px !important;
        max-height: 55px !important;
      }

      /* .page-height {
        height: calc(100dvh - 55px) !important;
      } */
      .break-keep {
        word-break: keep-all !important;
      }

      .page-default {
        width: 100%;
        height: calc(100dvh - 55px) !important;
        display: flex;
        flex-direction: column;
        overflow-y: auto;
      }
      .page-pd {
        padding: 15px !important;
      }
      .d-flex {
        display: flex !important;
      }
      .fd-c {
        flex-direction: column !important;
      }
      .jc-c {
        justify-content: center !important;
      }
      .jc-e {
        justify-content: flex-end !important;
      }
      .jc-sb {
        justify-content: space-between !important;
      }
      .jc-sa {
        justify-content: space-around !important;
      }
      .italic {
        font-style: italic !important;
      }
      .f-1 {
        flex: 1 !important;
      }
      .ai-e {
        align-items: flex-end !important;
      }
      .ai-s {
        align-items: flex-start !important;
      }
      .ai-c {
        align-items: center !important;
      }
      .as-c {
        align-self: center !important;
      }
      .as-str {
        align-self: stretch !important;
      }
      .as-s {
        align-self: flex-start !important;
      }
      .as-e {
        align-self: flex-end !important;
      }
      .gap {
        gap: 5px !important;
      }
      .gap-s {
        gap: 2.5px !important;
      }
      .gap-1 {
        gap: 5px !important;
      }
      textarea {
        padding-top: 10px;
        padding-bottom: 10px;
      }
      .input-box-type {
        border-style: solid;
        border-width: 1px;
        border-color: ${colors.gray.second};
        border-radius: 7.5px;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 16px;
        height: 45px;
        /* outline: auto; */
        outline-color: #d3d3d300;
        &:focus {
          outline: auto;
          border-color: #00000000;
          outline-color: ${colors.blue.third};
        }
        &::placeholder {
          font-size: 12px;
        }
        &.sm {
          height: 30px;
        }
      }
      .focus-outline {
        /* outline: auto; */
        outline-color: #d3d3d300;

        &:focus {
          outline: auto;
          border-color: #00000000;
          outline-color: ${colors.blue.third};
        }
      }

      @supports (-webkit-touch-callout: none) {
        /* CSS specific to iOS devices  아이폰*/
        * {
          outline-offset: 0px !important;
        }
      }

      .w-100 {
        width: 100% !important;
      }
      .h-100 {
        height: 100% !important;
      }

      .cursor-p {
        cursor: pointer !important;
      }
      .no-click {
        pointer-events: none !important;
      }
      .bold {
        font-weight: bold !important;
      }
      .fw-b {
        font-weight: bold !important;
      }
      .fw-n {
        font-weight: normal !important;
      }
      .fc-red {
        color: red !important;
      }

      /* Teeshot Text Styles */
      .text-body-14s {
        color: var(--Teeshot-Neutrals-Color-Teeshot-G1, #79818a);
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px;
      }

      .text-body-14 {
        color: var(--Teeshot-Neutrals-Color-Teeshot-G1, #79818a);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
      }

      .text-body-16s {
        color: var(--Teeshot-Neutrals-Color-Teeshot-G1, #79818a);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px;
      }

      .text-body-16 {
        color: var(--Teeshot-Neutrals-Color-Teeshot-G1, #79818a);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
      /* Bottom Navigation */
      .button-group {
        padding-bottom: 24px;
        display: flex;
        justify-content: center;
        gap: 8px;
        width: 100%;
      }

      /* Bottom Navigation */
      .bottom-nav {
        padding: 26px 16px;
        max-width: 800px;
        width: 100%;
        justify-content: center;
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        padding: 8px;
        background: linear-gradient(
          0deg,
          #fdfdfd 0%,
          #fdfdfd 60%,
          rgba(253, 253, 253, 0.3) 85%,
          rgba(253, 253, 253, 0) 100%
        );
        backdrop-filter: blur(10px);
        z-index: 1000;
      }

      .previous-button,
      .prev-button {
        display: flex;
        width: 100%;
        max-width: 400px;
        min-width: 170px;
        height: 60px;
        padding: 19px 20px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        background: white;
        color: #1a1a1a;
        border: 1px solid #1a1a1a;
        font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: transform 0.15s ease, filter 0.15s ease, background-color 0.15s ease;
        outline: none;
      }
      .previous-button:hover,
      .prev-button:hover {
        background-color: #f5f5f5;
      }
      .previous-button:active,
      .prev-button:active {
        background-color: #e5e5e5;
        transform: scale(0.975);
      }
      .previous-button:focus,
      .prev-button:focus,
      .previous-button:focus-visible,
      .prev-button:focus-visible {
        outline: none;
      }

      .next-button {
        display: flex;
        width: 100%;
        max-width: 400px;
        min-width: 170px;
        height: 60px;
        padding: 19px 20px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 10px;
        background: var(--Teeshot-Primary-Color-Teeshot-Green, #004b49);
        color: white;
        border: none;
        font-family: "Pretendard", -apple-system, Roboto, Helvetica, sans-serif;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: transform 0.15s ease, filter 0.15s ease, background-color 0.15s ease;
        outline: none;
      }
      .next-button:hover {
        filter: brightness(0.97);
      }
      .next-button:active {
        filter: brightness(0.9);
        transform: scale(0.975);
      }
      .next-button:focus,
      .next-button:focus-visible {
        outline: none;
      }
      .next-button:disabled {
        background-color: #d1d5d8 !important;
        color: #79818a !important;
        cursor: not-allowed !important;
        opacity: 0.6 !important;
      }
      ${() => {
        let cssString = "";
        for (let i = 1; i <= 10; i++) {
          cssString += `
            .gap-${String(i)} {
              gap: ${String(5 * i)}px;
            }

            .mb-${String(i)} {
              margin-bottom: ${String(5 * i)}px !important;
            }
            .mt-${String(i)} {
              margin-top: ${String(5 * i)}px !important;
            }
            .ml-${String(i)} {
              margin-left: ${String(5 * i)}px !important;
            }
            .mr-${String(i)} {
              margin-right: ${String(5 * i)}px !important;
            }
            .pd-${String(i)} {
              padding: ${String(5 * i)}px !important;
            }
            .pt-${String(i)} {
              padding-top: ${String(5 * i)}px !important;
            }
            .pb-${String(i)} {
              padding-bottom: ${String(5 * i)}px !important;
            }
            .pl-${String(i)} {
              padding-left: ${String(5 * i)}px !important;
            }
            .pr-${String(i)} {
              padding-right: ${String(5 * i)}px !important;
            }
            .fs-${String(i)} {
              font-size: ${String(8 + 2 * i)}px !important;
            }
            .flex-${String(i)} {
              flex: ${i} !important;
            }
            
          `;
        }
        return cssString;
      }}
      button {
        -webkit-tap-highlight-color: transparent;
        outline: none;
        -webkit-appearance: none;
        appearance: none;
      }
      button:focus,
      button:focus-visible {
        outline: none !important;
        box-shadow: none !important;
      }
      button::-moz-focus-inner {
        border: 0;
      }
    `;
  }}


`;

export default GlobalStyle;
